export default __webpack_public_path__ + "static/media/ANN-Rewards.cc03c7be.svg";